// removed by extract-text-webpack-plugin
module.exports = {"bar":"_9Udv5MzUbQOcWNjseKGXE","icon":"_2zB8wBo85kC0qePLxGkFz0","text":"_20kRoKwypmJZ2iAJ09sypO"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/molecules/ShareBar/style.css
// module id = 511
// module chunks = 38